import { render, staticRenderFns } from "./HotSpotBody.vue.js?vue&type=template&id=7ac20854&scoped=true!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./HotSpotBody.vue?vue&type=template&id=7ac20854&scoped=true"
import script from "./HotSpotBody.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./HotSpotBody.vue?vue&type=script&lang=js"
export * from "./HotSpotBody.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./HotSpotBody.vue?vue&type=script&lang=js"
import style0 from "./HotSpotBody.vue.scss?vue&type=style&index=0&id=7ac20854&prod&scoped=true&lang=scss!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./HotSpotBody.vue?vue&type=style&index=0&id=7ac20854&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac20854",
  null
  
)

export default component.exports